import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import StationTankSelect from './pureForm/StationTankSelect';
import _ from 'lodash';
import FMPText from './pureForm/FMPText';
import { withStyles } from '@material-ui/core';
import withMobileDialog from '@material-ui/core/withMobileDialog/withMobileDialog';
import DialogContent from '@material-ui/core/DialogContent';
import FMPDatePicker from './pureForm/FMPDatePicker';
import Transition from './Dialogs/Transition';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	label: {
		paddingRight: 5,
	},
	value: {
		fontWeight: 600,
	},
	new: {
		marginTop: 20,
	},
	current: {
		marginBottom: 15,
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
});

class AddInventoryDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			volume: '',
		};
	}

	componentDidUpdate(prevProps) {
		const { infoForAdd, open } = this.props;

		if (open && prevProps.infoForAdd !== infoForAdd) {
			if (infoForAdd.volume) {
				return this.setState({ volume: infoForAdd.volume });
			} else {
				return this.setState({ volume: '' });
			}
		}
	}

	handleRequestClose = () => {
		this.props.onClose();
	};

	handleAddUpdate = () => {
		const { infoForAdd, showErrors, addInventoryRecord, updateInventoryRecord } = this.props;
		let { stationId, tankNumber, day, inventoryRecordId } = infoForAdd;
		const { inventoryDate, stationTank, volume } = this.state;

		if (!volume) {
			return showErrors(['Volume is required']);
		}

		let inventoryDateTime;
		if (day) {
			day.hour(5).minute(30);
			inventoryDateTime = day.utc().format('YYYY-MM-DD HH:mm');
		} else {
			if (!inventoryDate) {
				return showErrors(['Date is required']);
			}
			inventoryDateTime = moment(inventoryDate).hour(5).minute(30).utc().format('YYYY-MM-DD HH:mm');
		}

		if (!stationId) {
			if (!stationTank) {
				return showErrors(['Please select a station']);
			}

			({ stationId, tankNumber } = stationTank);

			if (stationTank.productType !== 'e85') {
				return showErrors(['CAUGHT YOU! ONly e85 products are supported']);
			}

			if (!stationId) {
				return showErrors(['Station is required']);
			}
		}

		const params = {
			stationId,
			tankNumber,
			currentVolume: parseInt(volume.replace(/,/g, ''), 10),
			productType: 'e85',
		};

		if (!inventoryRecordId) {
			params.inventoryDateTime = inventoryDateTime;
		}
		if (inventoryRecordId) {
			params.inventoryRecordId = inventoryRecordId;
			updateInventoryRecord({
				params,
				callback: function (err) {
					if (!err) {
						this.props.onClose();
					}
				}.bind(this),
			});
		} else {
			addInventoryRecord({
				params,
				callback: function (err) {
					if (!err) {
						this.props.onClose();
					}
				}.bind(this),
			});
		}
	};

	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	getInputProps = (path, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { infoForAdd, classes, stations } = this.props;
		if (!infoForAdd) {
			return;
		}
		const { stationId, tankNumber, productType, number, name, day, inventoryRecordId } = infoForAdd;

		let title = 'Enter tank volume';
		let volumeLabel = day ? `Volume for morning of ${day.format('M/D')}` : 'Volume in the morning';

		if (inventoryRecordId || day) {
			volumeLabel = `Volume on ${day.format('dddd, M/D h:mm a')}`;
			title = `Change tank volume for ${day.format('dddd, M/D h:mm a')}`;
		}

		return (
			<Dialog
				classes={{ paper: classes.dialogPaper }}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleRequestClose}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						<span>{title}</span>
					</DialogTitle>

					<DialogContent style={{ fontSize: 18 }}>
						{stationId && (
							<div style={{ fontSize: 18 }}>
								Station :{' '}
								<strong>
									{number} - {name}
								</strong>
							</div>
						)}

						{!stationId && (
							<StationTankSelect
								{...this.getInputProps('stationTank', {})}
								label="Station / Tank"
								stations={stations || []}
								helpText={'NOTE : Only choose E85 tanks'}
							/>
						)}

						<div className={classes.current}>
							{tankNumber && (
								<div>
									<span className={classes.label}>Tank # : </span>
									<span className={classes.value}>{tankNumber}</span>
								</div>
							)}

							{productType && (
								<div>
									<span className={classes.label}>Product : </span>
									<span className={classes.value}>{productType.toUpperCase()}</span>
								</div>
							)}

							{day && (
								<div>
									<span className={classes.label}>Date / Time : </span>
									<span className={classes.value}>{day.format('dddd, M/D h:mm a')}</span>
								</div>
							)}
						</div>

						{!day && (
							<FMPDatePicker {...this.getInputProps('inventoryDate')} label={'Inventory Date'} />
						)}

						<FMPText {...this.getInputProps('volume')} label={volumeLabel} />
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose}>Cancel</Button>
						<Button
							variant="contained"
							onClick={this.handleAddUpdate}
							color="primary"
							className={classes.addInputButton}
						>
							{inventoryRecordId ? 'Update' : 'Add'}
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

AddInventoryDialog.propTypes = {
	open: PropTypes.bool,
	addInventoryRecord: PropTypes.func.isRequired,
	updateInventoryRecord: PropTypes.func.isRequired,
	infoForAdd: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
	stations: PropTypes.array,
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	isMorning: PropTypes.bool,
};

export default _.flow([withStyles(styles), withMobileDialog()])(AddInventoryDialog);
